export enum InvestigationReportSabrTag {
	Proposed = "SABR_PROPOSED",
	Edited = "EDITED_BY_INVESTIGATOR",
}
